const en = {
  metaTitle: "Overview",
  welcomeBack: "Welcome back",
  welcomeBackName: "Welcome back, {name}",
  happeningIn: "Here's what's happening in {store}.",

  // Range picker
  dateRange: "Date range",
  rangeToday: "Today",
  range7d: "7 days",
  range30d: "30 days",
  range90d: "90 days",
  salesFor_today: "Sales for today",
  salesFor_7d: "Sales for the last 7 days",
  salesFor_30d: "Sales for the last 30 days",
  salesFor_90d: "Sales for the last 90 days",

  // Metrics
  testExcluded: "Test-mode orders excluded · amounts in {currency}",
  paidOrders: "Paid orders",
  grossSales: "Gross sales",
  netSales: "Net sales",
  netSub: "Gross − discounts − refunds",
  aov: "Avg. order value",
  pendingPayment: "Pending payment",
  pendingSub: "{count} orders · not received yet",
  pendingSub_one: "{count} order · not received yet",
  refunds: "Refunds",
  def_paidOrders: "Orders with a confirmed payment (paid, partially refunded, refunded or disputed) placed in this period. Test-mode orders are excluded.",
  def_gross: "Sum of item subtotals before discounts, for orders with a confirmed payment. Excludes shipping and tax-only amounts. Test-mode orders excluded.",
  def_net: "Net sales = gross sales − discounts − refunds issued in this period. Test-mode orders excluded.",
  def_aov: "Average order value = (gross sales − discounts) ÷ paid orders.",
  def_pending: "Total of open orders still awaiting payment (e.g. bank transfer, cash on delivery, unfinished online payments). This money has NOT been received.",
  def_refunds: "Refunds that succeeded in this period, regardless of when the order was placed.",
  def_collected: "Amounts captured by your payment providers or marked as received for offline payments, before refunds. Provider fees are not included because they are charged by your provider.",
  def_customers: "Distinct customer emails with a paid order in this period.",
  def_repeat: "Customers (all time) with more than one paid order, out of all customers with a paid order.",
  chartTitle: "Net of discounts per day",
  chartDesc: "Paid orders only, by order date.",
  chartLabel: "Sales per day — {range}",
  fullAnalytics: "Full analytics →",
  noPaidOrdersPeriod: "No paid orders in this period yet.",
  salesHidden: "Sales figures are visible to roles with analytics access.",

  // Recent orders
  recentOrders: "Recent orders",
  allOrders: "All orders →",
  noOrdersYet: "No orders yet",
  ordersWillShow: "Orders will show up here as soon as customers check out.",
  publishToReceive: "Publish your store to start receiving orders.",
  colOrder: "Order",
  colCustomer: "Customer",
  colPayment: "Payment",
  colFulfillment: "Fulfillment",
  testBadge: "Test",
  fin_pending: "Pending",
  fin_awaiting_action: "Awaiting action",
  fin_authorized: "Authorized",
  fin_paid: "Paid",
  fin_partially_refunded: "Partially refunded",
  fin_refunded: "Refunded",
  fin_failed: "Failed",
  fin_cancelled: "Cancelled",
  fin_disputed: "Disputed",
  ful_unfulfilled: "Unfulfilled",
  ful_partially_fulfilled: "Partially fulfilled",
  ful_fulfilled: "Fulfilled",
  ful_not_required: "Not required",

  // Low stock
  lowStock: "Low stock",
  lowStockDesc: "Active products at or below their low-stock threshold.",
  inventoryLink: "Inventory →",
  nothingLow: "Nothing is running low.",
  sku: "SKU {sku}",
  outOfStock: "Out of stock",
  leftInStock: "{count} left",

  // Your store
  yourStore: "Your store",
  draftNotVisible: "Draft — not visible to customers",
  address: "Address",
  alsoAt: "Also: {url}",
  publicationSettings: "Publication settings",

  // Needs attention
  needsAttention: "Needs attention",
  noIssues: "No payment or fulfillment issues right now.",
  atCheckout: "At checkout: {methods}",
  issue_paidUnfulfilled: "{count} paid orders waiting to be fulfilled",
  issue_paidUnfulfilled_one: "{count} paid order waiting to be fulfilled",
  issue_failed: "{count} payments failed in the last 7 days",
  issue_failed_one: "{count} payment failed in the last 7 days",
  issue_disputed: "{count} disputed payments",
  issue_disputed_one: "{count} disputed payment",
  issue_awaiting: "{count} open orders awaiting payment (not yet received)",
  issue_awaiting_one: "{count} open order awaiting payment (not yet received)",
  issue_provider: "{provider}: {state}",
  issue_providerError: "{provider}: {state} — {error}",
  issue_noPayment: "No payment method is enabled — customers can't check out",
  payState_not_connected: "Not connected",
  payState_setup_required: "Setup required",
  payState_connected: "Connected · not enabled",
  payState_test_mode: "Active in checkout · Test mode",
  payState_active: "Active in checkout",
  payState_connection_problem: "Connection problem",
  payState_reauth_required: "Reauthorization required",
  payState_unavailable: "Temporarily unavailable",
  payState_not_supported: "Not yet supported",

  // Launch checklist
  launchChecklist: "Launch checklist",
  launchChecklistDesc: "Finish these steps to start selling. Progress is based on your store's real setup.",
  checklistLinksDesc: "Each item links to where you can complete it.",
  continueSetup: "Continue setup",
  blockersCount: "{count} items must be fixed before you can publish.",
  blockersCount_one: "{count} item must be fixed before you can publish.",
  viewRequirements: "View launch requirements →",
  stepsDone: "{done} of {total} steps done",
  launchProgress: "Launch progress",
  srDone: "(done)",
  srTodo: "(to do)",
  srOptional: "(optional)",
  optionalBadge: "Optional",
  doneBadge: "Done",
  check_store_created: "Create your store",
  check_branding: "Add your logo and brand style",
  check_products: "Add a product",
  check_payments: "Set up checkout payments",
  check_payments_tested: "Test your payment methods",
  check_shipping: "Configure shipping",
  check_policies: "Review your store policies",
  check_domain: "Connect a custom domain",
  check_published: "Publish your store",
  checkDetail_products: "At least one active product with a price.",
  checkDetail_payments: "Connect your own payment account or enable an offline method.",
  blocker_suspended: "This store is suspended by the platform. Contact support.",
  blocker_contactEmail: "Add a contact email in store settings.",
  blocker_homePage: "Your store needs a home page.",
  blocker_product: "Add at least one active product.",
  blocker_payment: "Enable at least one payment method that is ready for checkout.",
  blocker_shipping: "You sell physical products — add a shipping zone with at least one rate.",
  warning_policies: "Your policy pages still contain template text. Review them before launch.",
  warning_onlineUntested: "Some enabled online payment methods haven't passed a connection test.",
  warning_testMode: "A payment method is in test mode — customers can't make real payments with it.",

  // Errors / access
  errTitle: "Something went wrong",
  errBody: "We couldn't load this page. Check your connection and try again.",
  errForbiddenTitle: "You don't have access to this page",
  errForbiddenBody: "Your role in this store doesn't include this area. Ask the store owner for access.",
  noAccessTitle: "You don't have access to that area",
  noAccessBody: "Your role in {store} is {role}, which doesn't include it. Ask the store owner if you need access.",
  backToOverview: "Back to overview",

  // Onboarding
  setupTitle: "Set up your store",
  setupDesc: "A guided setup. Your progress is saved automatically — you can leave and come back at any time.",
  skipForNow: "Skip for now",
  setupSteps: "Setup steps",
  stepOf: "Step {step} of {total}",
  step_branding: "Branding",
  step_product: "First product",
  step_payments: "Payments",
  step_shipping: "Shipping",
  step_taxes: "Taxes",
  step_policies: "Policies",
  step_domain: "Domain",
  step_preview: "Preview",
  step_publish: "Publish",
  skipStep: "Skip this step",
  goToOverview: "Go to overview",
  logoTitle: "Add your logo",
  logoIntro: "Your logo appears in the storefront header, emails and browser tab.",
  logoLabel: "Logo",
  logoHint: "A PNG or SVG-like image with a transparent background works best.",
  saveLogo: "Save logo",
  logoSaved: "Logo saved.",
  errUploadLogo: "Upload a logo first.",
  colorsInBuilder: "Colors, fonts and layout are set in the",
  colorsInBuilderLink: "store builder",
  productTitle: "Add your first product",
  productIntro: "Start with one product — you can add variants, more images and SEO later in the full editor.",
  productAlready: "You already have an active product. You can add another here or continue.",
  productName: "Product name",
  productNamePh: "e.g. Handmade ceramic mug",
  stock: "Stock",
  stockHint: "Leave empty to not track stock.",
  typePhysical: "Physical (shipped)",
  typeService: "Service (no shipping)",
  imageOptional: "Image (optional)",
  addProduct: "Add product",
  fullProductEditor: "Use the full product editor (digital products, variants) →",
  errEnterPrice: "Enter a price.",
  productActive: "“{title}” is active in your catalog.",
  productFallback: "Product",
  paymentsTitle: "Choose how customers pay",
  paymentsIntro: "Payments go straight to your own accounts. You connect your own Stripe or PayPal account, or accept cash on delivery / bank transfer — the platform never collects payments for you and there's no fallback account.",
  customersCanPay: "Customers can pay with:",
  cantCheckout: "Customers can't check out until at least one payment method is enabled.",
  connectStripePaypal: "Connect Stripe or PayPal",
  cod: "Cash on delivery",
  codHint: "Customers pay on delivery; you mark orders paid when you receive the money.",
  enabledInCheckout: "Enabled in checkout",
  enableCod: "Enable cash on delivery",
  bankTransfer: "Bank transfer",
  bankDetails: "Bank details shown to customers",
  bankDetailsHint: "Account holder, IBAN / account number, bank, and the payment reference to use.",
  enableBank: "Enable bank transfer",
  askOwnerPayments: "Ask the store owner or an administrator to set up payments.",
  shippingTitle: "Set up shipping",
  shippingIntro: "Add a flat rate for orders delivered within {country}. You can add more zones and rate types later.",
  shippingNotRequired: "You don't have active physical products right now, so shipping isn't required. Set it up if you'll sell physical goods.",
  shippingHasRate: "You have at least one active shipping rate.",
  rateName: "Rate name",
  standardShipping: "Standard shipping",
  freeShipping: "Free shipping",
  priceZeroHint: "Use 0 for free shipping.",
  freeOver: "Free shipping on orders over",
  noFreeShipping: "No free shipping",
  deliveryEstimate: "Delivery estimate",
  deliveryEstimatePh: "e.g. 2–4 business days",
  saveShippingRate: "Save shipping rate",
  allShippingSettings: "All shipping settings →",
  shippingSetUp: "Shipping to {country} is set up.",
  taxesIntro: "Decide whether your prices include tax and add the rates you need to charge.",
  taxResponsibleTitle: "You are responsible for tax rates",
  taxResponsibleBody: "Storelancer applies the rates you enter; it does not determine which taxes apply to your business or calculate jurisdictional taxes automatically. Check with a tax advisor.",
  openTaxSettings: "Open tax settings",
  markReviewed: "Mark as reviewed",
  policiesTitle: "Review your policies",
  policiesIntro: "Your store was created with template pages for refunds, shipping, privacy and terms. Edit them to match how you actually do business before launch.",
  editPages: "Edit pages",
  policiesReviewed: "I've reviewed my policies",
  domainTitle: "Connect a domain (optional)",
  domainIntro: "Your store already has a free address on the platform. You can connect a domain you own at any time.",
  connectDomain: "Connect a domain",
  skipFreeAddress: "Skip — use the free address",
  previewTitle: "Preview your store",
  previewIntro: "See your storefront exactly as customers will, before anyone else can.",
  openPreview: "Open preview ↗",
  looksGood: "Looks good — continue",
  publishIntro: "When everything is ready, publish your store from the launch page. Nothing is published automatically.",
  stillRequired: "Still required before publishing",
  storeIsLive: "Your store is live.",
  everythingInPlace: "Everything required is in place.",
  goToPublish: "Go to launch & publish",
  errUnknownStep: "Unknown step",

  // Launch & publish
  publishDesc: "Check what's left before customers can visit and buy from your store.",
  thingsToFix: "{count} things to fix before publishing",
  thingsToFix_one: "{count} thing to fix before publishing",
  readyToPublish: "Ready to publish",
  allRequirementsMet: "All launch requirements are met.",
  allStepsComplete: "All required steps are complete.",
  recommendedBeforeLaunch: "Recommended before launch",
  publication: "Publication",
  firstPublished: "First published {date}.",
  onlyOwnerPublish: "Only the store owner or an administrator can publish or unpublish this store.",
  suspendedCantPublish: "This store is suspended by the platform and can't be published.",
  unpublishConfirmTitle: "Unpublish your store?",
  unpublishConfirmBody: "Customers will no longer be able to browse or buy. Orders, products and settings are kept, and you can publish again at any time. Checkouts already in progress can still be completed by the payment provider.",
  unpublishStore: "Unpublish store",
  publishStore: "Publish store",
  fixRedFirst: "Fix the items listed in red first. Your store will be re-checked when you publish.",
  publishConfirmTitle: "Publish your store?",
  publishConfirmBody: "Your storefront becomes visible to everyone and customers can place orders using the payment methods you enabled.",
  publishNow: "Publish now",
  previewStore: "Preview store ↗",
  publicAddresses: "Public addresses",
  platformAddress: "Platform address",
  primaryDomain: "Primary domain (verified)",
  connectDomainIn: "Connect a custom domain in",
  addressesNotAvailable: "These addresses show a “not available” page until you publish.",
  storeOffline: "Your store is offline. Customers now see a 'not available' page.",
};

export default en;
